"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.menuItemStyles = void 0;
const lit_1 = require("lit");
const list_item_styles_1 = require("@/components/common/list-item/list-item.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
exports.menuItemStyles = [
    list_item_styles_1.interactiveRowStyles,
    (0, lit_1.css) `
    /* tone=danger: color를 행에 지정하면 list-item 내부 텍스트·아이콘이 상속받는다 */
    :host([tone='danger']) ${shared_styles_1.interactiveElement} {
      color: var(--danger-color);
    }
  `,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVudS1pdGVtLnN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm1lbnUtaXRlbS5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQXlCO0FBRXpCLHFGQUFxRjtBQUNyRiwrREFBZ0U7QUFFbkQsUUFBQSxjQUFjLEdBQUc7SUFDNUIsdUNBQW9CO0lBQ3BCLElBQUEsU0FBRyxFQUFBOzs2QkFFd0Isa0NBQWtCOzs7R0FHNUM7Q0FDRixDQUFBIn0=